import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return null;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const STATUS_MESSAGES = {
  fr: {
    401: "Email ou mot de passe incorrect.",
    403: "Accès refusé.",
    404: "Ressource introuvable.",
    409: "Un compte existe déjà avec cet email.",
    422: "Certaines informations saisies sont invalides.",
    429: "Trop de tentatives. Réessayez dans quelques minutes.",
    server: "Le serveur est momentanément indisponible. Réessayez dans un instant.",
    timeout: "Délai dépassé. Vérifiez votre connexion et réessayez.",
    offline: "Vous êtes hors ligne. Vérifiez votre connexion Internet.",
    network: "Impossible de contacter le serveur. Vérifiez votre connexion, ou le service est momentanément indisponible.",
    unexpected: "Une erreur inattendue est survenue. Réessayez.",
  },
  en: {
    401: "Incorrect email or password.",
    403: "Access denied.",
    404: "Not found.",
    409: "An account already exists with this email.",
    422: "Some of the information entered is invalid.",
    429: "Too many attempts. Try again in a few minutes.",
    server: "The server is temporarily unavailable. Please try again shortly.",
    timeout: "Request timed out. Check your connection and try again.",
    offline: "You are offline. Check your internet connection.",
    network: "Cannot reach the server. Check your connection, or the service is temporarily unavailable.",
    unexpected: "An unexpected error occurred. Please try again.",
  },
};

// Returns a specific, human-readable error message from any axios error.
export function getApiErrorMessage(err, lang = "fr") {
  const M = STATUS_MESSAGES[lang] || STATUS_MESSAGES.fr;

  // 1) The server responded with an error status
  if (err?.response) {
    const { status, data } = err.response;
    const detail = formatApiErrorDetail(data?.detail);
    if (detail) return detail; // backend already sends a specific localized message
    if (M[status]) return M[status];
    if (status >= 500) return M.server;
    return (lang === "fr" ? `Erreur ${status}. Réessayez.` : `Error ${status}. Please try again.`);
  }

  // 2) The request was made but no response (network / CORS / DNS / offline)
  if (err?.request) {
    if (err.code === "ECONNABORTED" || /timeout/i.test(err.message || "")) return M.timeout;
    if (typeof navigator !== "undefined" && navigator.onLine === false) return M.offline;
    return M.network;
  }

  // 3) Something else went wrong building the request
  return M.unexpected;
}
